module.exports = __webpack_public_path__ + "site/img/team_sub_title_3.f40f94b2.svg";